import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const Login = () => {
  const navigate = useNavigate();
  
  const [formData, setFormData] = useState({
    mobile: '',
    password: ''
  });
  
  const [state, setState] = useState({
    spinner: false,
    hidePassword: true,
    errorMsg: ''
  });

  // Check if user is already logged in
  useEffect(() => {
    const isLoggedIn = localStorage.getItem('LoggedIn');
    if (isLoggedIn === '1') {
      navigate('/dashboard');
    }
  }, [navigate]);

  const setPasswordVisibility = () => {
    setState(prev => ({ ...prev, hidePassword: !prev.hidePassword }));
  };

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
    // Clear error when user starts typing
    if (state.errorMsg) {
      setState(prev => ({ ...prev, errorMsg: '' }));
    }
  };

  const handleStateChange = (field, value) => {
    setState(prev => ({ ...prev, [field]: value }));
  };

  const loginSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.mobile || !formData.password) {
      toast.error("Please enter username and password");
      return;
    }

    handleStateChange('spinner', true);
    handleStateChange('errorMsg', '');

    // Using FormData for API submission
    const formDataObj = new FormData();
    formDataObj.append('username', formData.mobile);
    formDataObj.append('password', formData.password);

    try {
      const response = await fetch('https://fx4money.com/Rest/wlogin_api2/', {
        method: 'POST',
        body: formDataObj,
      });

      const responseJson = await response.json();
      console.log('Login response:', responseJson);

      handleStateChange('spinner', false);

      if (responseJson.status === 0) {
        // Using localStorage instead of AsyncStorage for web
        localStorage.setItem("LoggedIn", '1');
        localStorage.setItem("name", responseJson.name);
        localStorage.setItem("email", responseJson.email);
        localStorage.setItem("username", responseJson.email);
        localStorage.setItem("userid", responseJson.userid);
        
        // Show success message
        toast.success('Login successful!');
        
        // Navigate to dashboard after a short delay
        setTimeout(() => {
          navigate('/dashboard');
        }, 1000);
        
      } else {
        handleStateChange('errorMsg', responseJson.msg);
        toast.error(responseJson.msg || 'Login failed');
      }
    } catch (error) {
      handleStateChange('spinner', false);
      handleStateChange('errorMsg', 'Network error occurred');
      console.error('Login error:', error);
      toast.error('Network error occurred. Please try again.');
    }
  };

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      
      {state.spinner && (
        <div 
          className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center" 
          style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1050 }}
        >
          <div className="text-center">
            <div className="spinner-border text-light" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="text-light mt-2">Logging in...</p>
          </div>
        </div>
      )}

      <div className="min-vh-100 d-flex flex-column" style={{ backgroundColor: '#fff' }}>
        <div className="container-fluid p-0">
          <div className="row g-0">
            <div className="col-12">
              <div 
                className="bg-primary text-white"
                style={{
                  height: '180px',
                  borderBottomLeftRadius: '50px',
                  borderBottomRightRadius: '50px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <h1 className="display-5 fw-bold mb-0">Welcome Back!</h1>
              </div>
            </div>
          </div>
        </div>

        <div className="container my-auto">
          <div className="row justify-content-center">
            <div className="col-md-6 col-lg-5">
              <div 
                className="card shadow-lg border-0 rounded-4"
                style={{
                  marginTop: '-40px',
                  backgroundColor: '#fff'
                }}
              >
                <div className="card-body p-4 p-md-5">
                  <h2 className="card-title fw-bold mb-4">Access Your Account</h2>
                  
                  {state.errorMsg && (
                    <div className="alert alert-danger" role="alert">
                      {state.errorMsg}
                    </div>
                  )}

                  <form onSubmit={loginSubmit}>
                    <div className="mb-3">
                      <label htmlFor="username" className="form-label">
                        Email / Mobile Number
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-lg"
                        id="username"
                        placeholder="Enter username or mobile number"
                        value={formData.mobile}
                        onChange={(e) => handleInputChange('mobile', e.target.value)}
                        style={{
                          height: '50px',
                          borderColor: '#ddd',
                          borderRadius: '8px',
                          fontSize: '16px'
                        }}
                        autoComplete="username"
                        required
                        disabled={state.spinner}
                      />
                    </div>

                    <div className="mb-4">
                      <label htmlFor="password" className="form-label">
                        Password
                      </label>
                      <div className="input-group">
                        <input
                          type={state.hidePassword ? 'password' : 'text'}
                          className="form-control form-control-lg"
                          id="password"
                          placeholder="Enter your password"
                          value={formData.password}
                          onChange={(e) => handleInputChange('password', e.target.value)}
                          style={{
                            height: '50px',
                            borderColor: '#ddd',
                            borderRadius: '8px 0 0 8px',
                            fontSize: '16px'
                          }}
                          autoComplete="current-password"
                          required
                          disabled={state.spinner}
                        />
                        <button
                          type="button"
                          className="btn btn-outline-secondary"
                          onClick={setPasswordVisibility}
                          style={{
                            height: '50px',
                            borderColor: '#ddd',
                            borderLeft: 'none',
                            borderRadius: '0 8px 8px 0'
                          }}
                          disabled={state.spinner}
                        >
                          <i className={`bi bi-eye${state.hidePassword ? '-slash' : ''}`}></i>
                        </button>
                      </div>
                      {/* <div className="text-end mt-2">
                        <Link to="/forgot-password" className="text-decoration-none text-primary small">
                          Forgot Password?
                        </Link>
                      </div> */}
                    </div>

                    <button
                      type="submit"
                      className="btn btn-primary btn-lg w-100"
                      style={{
                        height: '50px',
                        backgroundColor: '#1a5276',
                        borderColor: '#1a5276',
                        borderRadius: '8px',
                        fontSize: '18px',
                        fontWeight: 'bold'
                      }}
                      disabled={state.spinner}
                    >
                      {state.spinner ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                          LOGGING IN...
                        </>
                      ) : (
                        'LOGIN'
                      )}
                    </button>
                  </form>

                  <div className="text-center mt-4">
                    <p className="mb-0">
                      Don't have an account?{' '}
                      <Link 
                        className="text-decoration-none fw-bold"
                        style={{ color: '#1a5276' }} 
                        to='/register'
                      >
                        SIGN UP
                      </Link>
                    </p>
                  </div>

                 
                </div>
              </div>
            </div>
          </div>
        </div>

        <footer className="mt-auto py-3 text-center">
          <div className="container">
            <span className="text-muted">© {new Date().getFullYear()} Fx4Money</span>
           
          </div>
        </footer>
      </div>
    </>
  );
};

export default Login;